import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Compass } from "@phosphor-icons/react";

export function BriefBanners({ briefId, generatedContent, multiSectionContent }) {
  return (
    <>
      {briefId && (
        <motion.div initial={{ opacity: 0, y: -8 }} animate={{ opacity: 1, y: 0 }} className="bg-amber-500/10 border border-amber-500/20 rounded-lg px-4 py-3 flex items-center justify-between gap-3" data-testid="from-brief-banner">
          <p className="text-sm text-amber-400 font-medium">Generating from your content brief.</p>
          <Link to={`/briefs/${briefId}`} className="text-xs text-amber-400 hover:text-amber-300 font-medium whitespace-nowrap" data-testid="view-brief-link">View Brief &rarr;</Link>
        </motion.div>
      )}

      {!briefId && !generatedContent && !multiSectionContent && (
        <Link to="/briefs/new" className="block" data-testid="brief-builder-cta">
          <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} className="bg-[var(--bg-card)] border border-[var(--border)] rounded-lg p-4 flex items-center justify-between gap-3 hover:border-[#FF4400]/30 transition-colors group">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-lg bg-[#FF4400]/10 flex items-center justify-center shrink-0">
                <Compass size={18} className="text-[#FF4400]" weight="duotone" />
              </div>
              <div>
                <p className="text-sm font-medium text-[var(--text-primary)]">Not sure where to start?</p>
                <p className="text-xs text-[var(--text-muted)]">Build a content brief first — get AI-powered topic angles and strategic instructions.</p>
              </div>
            </div>
            <span className="text-xs text-[#FF4400] font-medium whitespace-nowrap group-hover:translate-x-0.5 transition-transform">Build Brief &rarr;</span>
          </motion.div>
        </Link>
      )}
    </>
  );
}
